import { Fragment } from "react";
import * as utils from "common/utils";
import { LoadingPanel } from "components/LoadingPanel";
import Watermark from "components/Watermark";
import { SummaryRow } from "components/PlanningReport";
import { useAnalysisResults } from "containers/BudgetHome";

export default function AnimalsSummaryByEnterprise({ before, after }) {
    const { isLoading: beforeIsLoading, data: beforeResults } = useAnalysisResults(before?.details);
    const { isLoading: afterIsLoading, data: afterResults } = useAnalysisResults(after?.details);

    const isLoading = afterIsLoading || (before && beforeIsLoading);
    const isComparing = !!before && !!after;

    // Cater for the distinct union of enterprises when comparing
    const beforeEnterpriseNames = beforeResults?.animals?.stockingRates?.byEnterprise?.map((e) => e.name) || [];
    const afterEnterpriseNames = afterResults?.animals?.stockingRates?.byEnterprise?.map((e) => e.name) || [];
    const distinctEnterpriseNames = [...new Set([...beforeEnterpriseNames, ...afterEnterpriseNames])];

    return (
        <div className="ReportSection">
            <h1>Enteprise RSU</h1>
            <LoadingPanel isLoading={isLoading}>
                <div className="Table Table-Compressed">
                    <Watermark />
                    <table>
                        <thead>
                            <tr>
                                <th data-width="25"></th>
                                <th></th>
                                {isComparing && (
                                    <th className="numeric u-before" data-width="12.5">
                                        {utils.truncateText(before.displayName, 35)}
                                    </th>
                                )}
                                <th className={`numeric ${isComparing ? "u-after" : ""}`} data-width="12.5">
                                    {utils.truncateText(after.displayName, 35)}
                                </th>
                                {isComparing && (
                                    <th className="numeric" data-width="16.7">
                                        Change
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {distinctEnterpriseNames?.map((enterpriseName) => {
                                const beforeEnterprise = beforeResults?.animals?.stockingRates?.byEnterprise?.find((e) => e.name === enterpriseName);
                                const afterEnterprise = afterResults?.animals?.stockingRates?.byEnterprise?.find((e) => e.name === enterpriseName);
                                return (
                                    <Fragment key={enterpriseName}>
                                        <SummaryRow beforeValue={beforeEnterprise?.total?.value} afterValue={afterEnterprise?.total?.value} isComparing={isComparing} category={beforeEnterprise?.name || afterEnterprise?.name} label="Total" unit={afterEnterprise?.total?.unit?.notation} />
                                        <SummaryRow beforeValue={beforeEnterprise?.byGrazedArea?.value} afterValue={afterEnterprise?.byGrazedArea?.value} isComparing={isComparing} category=" " label="RSU per grazed area" unit={afterEnterprise?.byGrazedArea?.unit?.notation} dp={2} />
                                        <SummaryRow beforeValue={beforeEnterprise?.byFarmArea?.value} afterValue={afterEnterprise?.byFarmArea?.value} isComparing={isComparing} category=" " label="RSU per farm area" unit={afterEnterprise?.byFarmArea?.unit?.notation} dp={2} />
                                    </Fragment>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </LoadingPanel>
        </div>
    )
}
